/**
 * <strong>Purpose:</strong> <br>
 * Provides the ability to set a value of an input-type widget(textfield, textarea)
 * <br><br>
 *
 *
 * <strong>Contract:</strong> <br>
 * <em>Attach-point:</em> inputNode <br>
 * If the widget provides the above attach point which should be an HTML INPUT element, the mixin updates its "value"
 * property
 *
 * @module mw-form/mixins/property/TextInputValueMixin
 *
 * @copyright Copyright 2014 The MathWorks, Inc.
 */

define([
    "dojo/_base/declare",
    "dojo/on"
], function (declare, on) {

    return declare(null, {

        /**
         * @property  {String} value - text content that goes into the input area of the widget
         * @instance
         * @default ""
         */
        value: "",

        postCreate: function () {
            this.inherited(arguments);
            this.domNode.classList.add("mwTextInputValueMixin");
            // When the default value is falsy, the setter will not be triggered during the widget's construction phase
            // We need to call the setter explicitly
            this._setValueAttr(this.get("value"));
            this._stopChangeEventBubbling();
        },

        _setValueAttr: function (value) {

            //TODO: explore and see if we need data type checking
            //Update inputnode dom's to reflect new value
            this.setValueInDom(value);
            this._set("value", value);

        },

        _stopChangeEventBubbling: function () {

            //Input elements have a change event that will bubble up the widget
            //Stop onchange event of input field to reach widget  and emit change event
            //http://www.quirksmode.org/js/events_order.html
            this.own(on(this.inputNode, "change", function (event) {
                event.stopPropagation();
            }));
        },

        setValueInDom: function(value) {
            if (this.inputNode !== undefined) { // sanity check in case node was just destroyed e.g. by dialog dismissal
                this.inputNode.value = value;
            }
        }
    });

});
